import React, { Component } from "react";
import LoginForm from "./Login/LoginForm";
import LoginBanner from "./Login/LoginBanner";
import "./landing-screen.styles.css";
import OtpForm from "./Login/OtpForm";
import ReceivedOtp from "./Login/ReceivedOtp";
import InformationCard from "./common/information-card.component";
import ForgotUsername from "./Forgot-User-Details/ForgotUsername";
import ForgotPassword from "./Password/ForgotPassword";
import CreateProfile from "./Registration/CreateProfile";
import RegistrationOtp from "./Registration/RegistrationOtp";
import CreatePassword from "./Registration/CreatePassword";
import ForgotPasswordForm from "./Password/ForgotPasswordForm";
import { getLoggedInState, activateFromEmail } from "../services/rest";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorHandler from "../utils/error-handler";

toast.configure();
class LandingScreen extends Component {
  state = {
    currentScreen: "NONE",
    screenData: {},
    loginJourneyFlag: true,
    redirectUrl: null,
    isOldLogin: false
  };
  componentDidMount() {
    this.checkLoggedInState();
  }
  checkLoggedInState = async () => {
    try {
      this.props.showUILoader(true);
      let redirectUrl = this.getRedirectUrl();
      const response = await getLoggedInState();
      if (response.data && response.data.result) {
        const logggedState = response.data.result.loggedIn;
        if (logggedState) {
          if (redirectUrl == null || redirectUrl === '') {
            window.location.href = response.data.result.landingPageUrl;
          } else {
            window.location = redirectUrl;
          }
        }
      }
    } catch (error) {
      // Ignoring error case to proceed as though, loggedinState is false.
    } finally {
      this.props.showUILoader(false);
      this.getDefaultScreen();
    }
  };
  getDefaultScreen = async () => {
    const currentUrlPath = window.location.href;
    const allowedOldHost = ['wwwdev.vodacom.co.za', 'wwwqa.vodacom.co.za', 'wwwstg.vodacom.co.za']
    this.setState({ isOldLogin: allowedOldHost.includes(window.location.hostname) && currentUrlPath.indexOf("loginPassword") !== -1 });

    if (currentUrlPath.indexOf("registration") !== -1) {
      const activationCodeIndex = currentUrlPath.indexOf("code=");
      if (activationCodeIndex !== -1) {
        const activationCode = currentUrlPath.slice(
          activationCodeIndex + 5,
          currentUrlPath.length
        );
        try {
          this.props.showUILoader(true);
          const response = await activateFromEmail(activationCode);
          if (response.data && response.data.result) {
            const message = response.data.result.message || "";
            this.changeScreen("LOGIN", { toastMessage: message });
          } else {
            throw new Error("UNEXPECTED_ERROR");
          }
        } catch (error) {
          ErrorHandler.handleEmailActivationError(error, this.changeScreen);
        } finally {
          this.props.showUILoader(false);
        }
      } else {
        this.changeScreen("CREATE_PROFILE");
      }
    } else if (currentUrlPath.indexOf("forgot-password") !== -1) {
      this.changeScreen("FORGOT_PASSWORD")
    } else {
      this.changeScreen("LOGIN");
    }
  };
  getRedirectUrl = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params.redirectUrl != null && params.redirectUrl !== '') {
      const redirectUrl = params.redirectUrl
      this.setState({
        redirectUrl
      });
    }
    return params.redirectUrl;
  };
  notify = (message) => {
    toast.dismiss();
    toast.success(message, { position: toast.POSITION.BOTTOM_LEFT });
  };
  changeScreen = (screen, data = {}) => {
    toast.dismiss();
    this.updateBannerText(screen);
    this.setState({ currentScreen: screen, screenData: data });
  };
  updateBannerText = (screen) => {
    if (screen === "LOGIN") {
      this.setState({ loginJourneyFlag: true });
    } else if (screen === "CREATE_PROFILE") {
      this.setState({ loginJourneyFlag: false });
    }
    return;
  };

  render() {
    const {
      currentScreen,
      screenData,
      loginJourneyFlag,
      redirectUrl,
      isOldLogin
    } = this.state;
    return (
      <div className="landing-screen-wrapper">
        <div className="landing-banner-wrapper">
          <LoginBanner loginJourneyFlag={loginJourneyFlag} />
        </div>
        <div className="landing-content-wrapper">
          <div
            className={`landing-content-card ${
              currentScreen === "NONE" ? "default-content-card" : ""
            } ${
              currentScreen === "CREATE_PROFILE" ? "create-profile-card" : ""
            }`}
          >
            <form>
              {currentScreen === "LOGIN" && (
                <LoginForm
                  data={screenData}
                  goto={this.changeScreen}
                  showUILoader={this.props.showUILoader}
                  redirectUrl={redirectUrl}
                  isOldLogin={isOldLogin}
                />
              )}

              {currentScreen === "LOGIN_OTP" && (
                <ReceivedOtp
                  data={screenData}
                  goto={this.changeScreen}
                  showUILoader={this.props.showUILoader}
                />
              )}
              {currentScreen === "ENTER_OTP" && (
                <OtpForm
                  data={screenData}
                  goto={this.changeScreen}
                  showUILoader={this.props.showUILoader}
                  redirectUrl={redirectUrl}
                />
              )}
              {currentScreen === "INFORMATION_CARD" && (
                <InformationCard
                  data={screenData}
                  goto={this.changeScreen}
                  showUILoader={this.props.showUILoader}
                />
              )}
              {currentScreen === "FORGOT_USERNAME" && (
                <ForgotUsername
                  goto={this.changeScreen}
                  data={screenData}
                  showUILoader={this.props.showUILoader}
                />
              )}
              {currentScreen === "FORGOT_PASSWORD" && (
                <ForgotPassword
                  goto={this.changeScreen}
                  data={screenData}
                  showUILoader={this.props.showUILoader}
                />
              )}
              {currentScreen === "FORGOT_PASSWORD_OTP" && (
                <ForgotPasswordForm
                  data={screenData}
                  goto={this.changeScreen}
                  showUILoader={this.props.showUILoader}
                />
              )}
              {currentScreen === "CHANGE_PASSWORD" && (
                <CreatePassword
                  data={screenData}
                  goto={this.changeScreen}
                  changeFlag={true}
                  showUILoader={this.props.showUILoader}
                />
              )}
              {currentScreen === "CREATE_PROFILE" && (
                <CreateProfile
                  data={screenData}
                  goto={this.changeScreen}
                  showUILoader={this.props.showUILoader}
                />
              )}
              {currentScreen === "CREATE_PASSWORD" && (
                <CreatePassword
                  data={screenData}
                  goto={this.changeScreen}
                  showUILoader={this.props.showUILoader}
                />
              )}

              {currentScreen === "REGISTRATION_OTP" && (
                <RegistrationOtp
                  data={screenData}
                  goto={this.changeScreen}
                  showUILoader={this.props.showUILoader}
                  redirectUrl={redirectUrl}
                />
              )}
            </form>
          </div>
        </div>
        <ToastContainer
          containerId={"appToastContainer"}
          position={toast.POSITION.BOTTOM_LEFT}
        />
      </div>
    );
  }
}

export default LandingScreen;
